import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import InfoTooltip from '../../../InfoTooltip/InfoTooltip';
import styles from '../Messages.module.scss';

const PaOverageMessage = () => {
  const t = useTranslations();

  const renderTooltipContent = () => (
    <span
      className={styles.tooltipContent}
      data-testid="tooltip-content"
    >
      {t('overage_tooltip')}
    </span>
  );

  return (
    <div
      className={styles.buyCardMessage}
      data-testid="pa-overage-message"
    >
      {t('premium_access_in_overage')}
      <InfoTooltip content={renderTooltipContent()} />
    </div>
  );
};

export default PaOverageMessage;
